export default {
    popupBody: {
        padding: "0 40px 40px 40px",
        maxHeight: '80vh',
    },

    rowsGap: {
        rowGap: "10px"
    },

    overlayStyles: {
        minWidth: "60%"
    },

    calendar: {
        width: "20%"
    },

    dropdownBox: {
        width: "100%"
    },

    footer: {
        display: "flex",
        columnGap: "20px",
        justifyContent: "end",
        margin: "40px 0 0 0"
    },

    buttons: {
        width: "140px",
        height: "40px",
    },
}